const SITE_REQUIRED_ROUTE_PREFIXES: string[] = ["/produce/production/plan-builder"];

export const matchesSiteRequiredPrefix = (pathname: string, prefixes: string[]): boolean =>
	prefixes.some((prefix) => pathname === prefix || pathname.startsWith(`${prefix}/`));

const isSiteRequiredForPath = (pathname: string): boolean =>
	matchesSiteRequiredPrefix(pathname, SITE_REQUIRED_ROUTE_PREFIXES);

export default isSiteRequiredForPath;
